import { apiPost } from '../utils/api';
import { fetchAuthSession } from '@aws-amplify/auth';

const API_NAME = 'analytics';

export async function fetchAdminGameAnalytics({
  startDate,
  endDate,
  currency = null,
  tab = 'overview'
} = {}) {
  if (!startDate || !endDate) {
    throw new Error('Start date and end date are required');
  }

  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();

  const response = await apiPost(
    API_NAME,
    '/adminanalytics',
    {
      startDate: startDate instanceof Date ? startDate.toISOString() : startDate,
      endDate: endDate instanceof Date ? endDate.toISOString() : endDate,
      currency,
      tab
    },
    token
  );

  if (!response?.success) {
    throw new Error(response?.error || 'Failed to fetch admin analytics');
  }

  return response;
}
